import { THour, TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';

const getTimeOfDay = (state: TInitialState): THour[] => {
    const { selected: { date }, slots } = state;
    if (date && slots[date]) {
        return Object.values(slots[date].hours);
    } else {
        return [];
    }
};

export default getTimeOfDay;
